<template>
  <div class="w-100" style="padding: 0;">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4 w-100 shadow-sm">
          <div class="card-body px-4 py-3">
            <titles text="Ödəniş cədvəli" />
            <div class="d-flex align-items-center mb-3 " v-if="agreedAmount">
              <hr class="my-2" />
              <soft-button type="button" class="btn bg-gradient-success" @click="handleInvoiceClick">
                <i class="fa fa-file-invoice"></i>&nbsp;Hesab-faktura yarat
              </soft-button>
              &nbsp;
              &nbsp;
              <soft-button type="button" class="btn bg-gradient-light ml-2"
                @click="$emit('open-invoices-timeline-dialog')">
                <i class="fa fa-list"></i>&nbsp;Hesab-fakturalar
              </soft-button>
            </div>
            <hr>

            <div v-if="status !== 50" class="d-flex flex-wrap mt-2">
              <button type="button" class="btn bg-gradient-success" @click="openModal(false)">
                <i class="fa fa-plus font-weight-bold"></i>&nbsp;&nbsp;Yeni yazı
              </button>
              &nbsp;
              &nbsp;
              <button type="button" class="btn" style="background: #008B8B; color: white;"
                @click="openGenerateInstallmentsModal">
                <i class="fa fa-calendar-alt font-weight-bold"></i>&nbsp;&nbsp;Ödəniş cədvəli yarat
              </button>
            </div>
            <el-alert v-if="isPaymentMismatch"
              title="Diqqət! Ödəniş cədvəli yekun razılaşdırılmış məbləğ ilə uyğun deyil." type="warning" show-icon
              :closable="false" class="mb-3" />

            <PaymentsTable :status="status" :payments="payments" @edit-payment="openEditModal"
               @delete-payment="id => deletePayment(id, false)" />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card mb-4 w-100 shadow-sm">
          <div class="card-body px-4 py-3">
            <titles text="Ödənişlər" />
            <hr class="my-2">

            <button v-if="status !== 50" type="button" class="btn bg-gradient-success" @click="openModal(true)">
              <i class="fa fa-plus font-weight-bold"></i>&nbsp;&nbsp;Yeni yazı
            </button>

            <CompletedPaymentsTable :status="status" :completed-payments="completedPayments"
              @edit-completed-payment="p => openEditModal(p, true)"
              @delete-completed-payment="id => deletePayment(id, true)" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="isModalOpen" width="25%" :title="isEditing ? 'Ödənişi yenilə' : 'Ödəniş Əlavə Et'">
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-12 mt-2">
            <label class="form-label">Tarix</label>
            <el-date-picker v-model="newPayment.date" format="DD.MM.YYYY" style="width: 100%;" size="large" type="date"
              placeholder="Seçin" />
          </div>

          <div class="col-12 mt-3">
            <label class="form-label">Məbləğ</label>
            <el-input v-model="newPayment.amount" size="large" placeholder="Məbləğ daxil edin" />
          </div>

          <div class="col-12 mt-3">
            <label class="form-label">Qeydlər</label>
            <el-input v-model="newPayment.description" size="large" placeholder="Qeyd daxil edin" />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <soft-button type="button" @click="savePayment(isCompletedPayment)">
          Yadda saxla
        </soft-button>
        &nbsp;
        &nbsp;
        <soft-button type="button" color="secondary" @click="isModalOpen = false">İmtina</soft-button>
      </div>
    </el-dialog>


    <!-- Modal: Ödəniş cədvəli -->
    <el-dialog v-model="isGenerateInstallmentsModalOpen" width="25%" title="Ödəniş cədvəli yarat">
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-12 mt-2">
            <label class="form-label">Başlanğıc tarixi</label>
            <el-date-picker v-model="installmentData.startDate" size="large" type="date" format="DD.MM.YYYY"
              value-format="YYYY-MM-DD" style="width: 100%;" placeholder="Tarix daxil edin" />
          </div>

          <div class="col-12 mt-3">
            <label class="form-label">Ayların sayı</label>
            <el-select v-model="installmentData.months" placeholder="Seçin" size="large" style="width: 100%;">
              <el-option v-for="month in 11" :key="month + 1" :label="month + 1" :value="month + 1" />
            </el-select>
          </div>

          <div class="col-12 mt-3">
            <label class="form-label">Yekun məbləğ</label>
            <el-input v-model="subrogationAmount" size="large" disabled />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <soft-button type="button" @click="generateInstallments">Yarat</soft-button>
        &nbsp;
        &nbsp;
        <soft-button type="button" color="secondary" @click="closeGenerateInstallmentsModal">İmtina</soft-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import PaymentsTable from "./Tables/PaymentsTable.vue";
import CompletedPaymentsTable from "./Tables/CompletedPaymentsTable.vue";
import {
  CreatePayment,
  GetPayments,
  UpdatePayment,
  GenerateInstallments,
  DeleteInstallments,
  GetCompletedPayments,
  CreateCompletedPayment,
  UpdateCompletedPayment,
  DeletePayment,
  DeleteCompletedPayment
}
  from "@/project/Source/subrogations";
import Titles from "@/project/Components/Titles.vue";

export default {
  components: {
    Titles,
    PaymentsTable,
    CompletedPaymentsTable,
    SoftButton
  },
  props: {
    sourceType: Number,
    id: [String, Number],
    data: {
      type: Object,
    },
    participant: {
      Number
    },
    agreedAmount: {
      Number
    },
    status: {
      Number
    },
  },
  data() {
    return {
      payments: [],
      completedPayments: [],
      isModalOpen: false,
      isGenerateInstallmentsModalOpen: false,
      isCompletedPayment: false,
      newPayment: { date: '', amount: '', description: '' },
      isEditing: false,
      editingPaymentId: null,
      installmentData: { startDate: '', totalAmount: '', months: '' },
      subrogationAmount: null,
      loading: false,
    };
  },
  watch: {
    agreedAmount: {
      immediate: true,
      handler(val) {
        this.subrogationAmount = val;
      }
    },
    id(newVal) {
      this.fetchPayments(newVal);
      this.fetchCompletedPayments();
    }
  },
  mounted() {
    if (this.id) {
      this.fetchPayments();
      this.fetchCompletedPayments();
    }
  },
  computed: {
    totalPayments() {
      return this.payments.reduce((sum, p) => sum + Number(p.amount || 0), 0);
    },
    isPaymentMismatch() {
      return this.agreedAmount > 0 && this.totalPayments !== this.agreedAmount;
    },
    canCreateInvoice() {
      return this.payments.length > 0;
    }
  },
  methods: {
    handleInvoiceClick() {
      if (!this.payments.length) {
        this.$message.warning("Ödəniş cədvəli olmadan invoice yaratmaq olmaz.");
        return;
      }
      this.$emit('open-invoice-dialog');
    },
    async deletePayment(id, isCompleted = false) {
      const result = await this.$swal({
        title: "Təsdiq edin",
        text: "Silmək istədiyinizə əminsiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "İmtina",
        confirmButtonText: "Təsdiq et",
        customClass: {
          confirmButton: "btn bg-gradient-info",
          cancelButton: "btn bg-gradient-secondary",
        },
        buttonsStyling: false,
      });

      if (!result.isConfirmed) return;

      this.loading = true;
      const service = isCompleted ? DeleteCompletedPayment : DeletePayment;
      const fetch = isCompleted ? this.fetchCompletedPayments : this.fetchPayments;
      const requestCorrelationId = crypto.randomUUID();
      const commandUserId = this.$store.state.user.id;

      service(id, commandUserId, requestCorrelationId)
        .then(res => {
          if (res.data?.isSuccess) {
            this.$message.success("Uğurlu əməliyyat!");
            fetch();
          } else {
            this.$message.error(res.data?.message || "Xəta baş verdi.");
          }
        })
        .catch(() => this.$message.error("Silinmə zamanı xəta baş verdi."))
        .finally(() => { this.loading = false; });
    },
    getPaymentSum() {
      return this.payments.reduce((sum, p) => sum + Number(p.amount || 0), 0);
    },
    openModal(isCompleted = false) {
      this.isModalOpen = true;
      this.isCompletedPayment = isCompleted;
      this.isEditing = false;
      this.editingPaymentId = null;
      this.newPayment = { date: '', amount: '', description: '' };
    },
    openEditModal(payment, isCompleted = false) {
      this.isModalOpen = true;
      this.isEditing = true;
      this.isCompletedPayment = isCompleted;
      this.editingPaymentId = payment.id;
      this.newPayment = {
        date: this.formatDateForPicker(payment.paymentDate),
        amount: payment.amount.toString(),
        description: payment.description
      };
    },

    closeModal() {
      this.isModalOpen = false;
      this.isEditing = false;
      this.editingPaymentId = null;
      this.newPayment = { date: '', amount: '', description: '' };
    },


    openGenerateInstallmentsModal() {
      this.isGenerateInstallmentsModalOpen = true;
    },
    closeGenerateInstallmentsModal() {
      this.isGenerateInstallmentsModalOpen = false;
      this.installmentData = { startDate: '', totalAmount: '', months: '' };
    },
    async generateInstallments() {

      if (!this.installmentData.startDate || !this.subrogationAmount || !this.installmentData.months) {
        return this.$message.error("Zəhmət olmasa bütün sahələri doldurun.");
      }

      this.loading = true;
      try {
        await DeleteInstallments(this.participant);

        const payload = {
          participantId: this.participant,
          startDate: this.installmentData.startDate,
          totalAmount: parseFloat(this.subrogationAmount),
          months: parseInt(this.installmentData.months),
          sourceType: this.sourceType,
          subrogationId: this.id
        };

        const response = await GenerateInstallments(payload);

        if (response.data?.isSuccess) {
          this.$message.success("Ödəniş cədvəli uğurla yaradıldı!");
          this.closeGenerateInstallmentsModal();
          this.fetchPayments();
        } else {
          this.$message.error(response.data.message || "Xəta baş verdi.");
        }
      } catch (error) {
        this.$message.error("Xəta baş verdi. Yenidən cəhd edin.");
      } finally {
        this.loading = false;
      }
    },


    formatDateForPicker(dateStr) {
      const parts = dateStr.split('.');
      return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : dateStr;
    },
    resetNewPayment() {
      this.newPayment = { date: '', amount: '', description: '' };
    },
    async fetchPayments() {
      this.loading = true;
      try {
        const { data } = await GetPayments(this.participant);
        this.payments = data.data.map(payment => ({
          ...payment,
          paymentDate: this.formatDate(payment.paymentDate)
        }));
      } catch (error) {
        this.$message.error("Ödəniş məlumatları yüklənə bilmədi.");
      } finally {
        this.loading = false;
      }
    },
    async fetchCompletedPayments() {
      this.loading = true;
      try {
        const { data } = await GetCompletedPayments(this.participant);
        this.completedPayments = data.data.map(payment => ({
          ...payment,
          paymentDate: this.formatDate(payment.paymentDate)
        }));
      } catch (error) {
        this.$message.error("Tamamlanmış ödənişlər yüklənə bilmədi.");
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, '0');
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const year = parsedDate.getFullYear();
      return `${day}.${month}.${year}`;
    },
    normalizeDate(dateString) {
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    },
    async savePayment(isCompleted = false) {
      if (!this.newPayment.date || !this.newPayment.amount) {
        return this.$message.error("Tarix və məbləğ məlumatlarını tam daxil edin.");
      }

      this.loading = true;
      const paymentToSave = {
        paymentDate: this.newPayment.date,
        amount: parseFloat(this.newPayment.amount),
        description: this.newPayment.description,
        subrogationid: this.id,
        participantid: this.participant,
        sourceType: this.sourceType,
      };

      try {
        let response;

        if (this.isEditing) {
          response = isCompleted
            ? await UpdateCompletedPayment({ ...paymentToSave, id: this.editingPaymentId })
            : await UpdatePayment({ ...paymentToSave, id: this.editingPaymentId });
        } else {
          response = isCompleted
            ? await CreateCompletedPayment(paymentToSave)
            : await CreatePayment(paymentToSave);
        }


        if (response.data?.isSuccess) {
          this.$message.success("Uğurlu əməliyyat!");
          this.closeModal();
          this.fetchPayments();
          this.fetchCompletedPayments();
        } else {
          this.$message.error(response.data?.message || "Xəta baş verdi");
        }
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          (typeof error.response?.data === "string" ? error.response.data : null) ||
          error.message || "Verilənlər yadda saxlanmadı.";

        this.$message.error(msg);
      } finally {
        this.loading = false;
      }

    }


  },
};
</script>

<style></style>